// store/getters.ts
import { GetterTree } from 'vuex'
import { State } from './_state'
import { RootState } from '@/store'
import { notificationGroupData } from '@/components/notifications-list/notifications'

export enum getterNames {
  ALL_NOTIFICATIONS = 'ALL_NOTIFICATIONS',
  HAS_NOTIFICATIONS = 'HAS_NOTIFICATIONS',
}

export const getters: GetterTree<State, RootState> = {
  /**
   * Returns all notifications.
   * @param {State} state - The Vuex state
   * @returns {Array<notificationGroupData>} List of all notification groups
   */
  [getterNames.ALL_NOTIFICATIONS]: (state): Array<notificationGroupData> =>
    state.notifications,

  [getterNames.HAS_NOTIFICATIONS]: (state): boolean => {
    const n = state.notifications.reduce((total, group) => {
      return total + (group.notifications.length || 0)
    }, 0)
    return n > 0
  },
}
